export default "__VITE_ASSET__C$9L8k3$__"